import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Spinner,
  DropdownMenu,
  Card,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import userAvatar from "assets/img/userAvatar.png";
import {
  getUnreadNotfications,
  clearAllNotifications,
  updateNotification,
} from "store/actions/RequestActions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import bell from "assets/img/bell icon.png";
import activeBell from "assets/img/icons/bell.svg";

const Notifications = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    unreadLoader,
    clearAllLoader,
    unreadNotifications,
    getNotificationsLoader,
  } = useSelector((state) => state.requests);

  const { user, userPermissions } = useSelector((state) => state.auth);
  const [showActiveBell, setShowActiveBell] = useState(false);
  const [previousNotificationCount, setPreviousNotificationCount] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const editAccess =
    user?.type === "restaurant" ||
    userPermissions?.notifications?.options?.edit;
  const getAccess =
    user?.type === "restaurant" || userPermissions?.notifications?.options?.get;

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    if (showActiveBell) {
      setShowActiveBell(false);
    }
  };
  const handleClearAll = () => {
    dispatch(clearAllNotifications(user?.restaurantID));
  };
  useEffect(() => {
    if (unreadNotifications?.length !== previousNotificationCount) {
      if (unreadNotifications?.length > previousNotificationCount) {
        setShowActiveBell(true);
      } else {
        setShowActiveBell(false);
      }
      setPreviousNotificationCount(unreadNotifications?.length || 0);
    }
  }, [previousNotificationCount, unreadNotifications]);

  useEffect(() => {
    if (!user?.restaurantID) return;

    let unsubscribe;

    (async () => {
      unsubscribe = await dispatch(getUnreadNotfications(user.restaurantID));
    })();

    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [user?.restaurantID, dispatch]);

  return (
    <>
      <UncontrolledDropdown nav isOpen={isDropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle nav>
          <img
            src={showActiveBell ? activeBell : bell}
            alt="Bell"
            onClick={toggleDropdown}
            style={{
              width: showActiveBell ? "30px" : "40px",
              height: showActiveBell ? "30px" : "40px",
            }}
          />
        </DropdownToggle>
        {isDropdownOpen && (
          <DropdownMenu
            className="dropdown-menu-arrow custom-dropdown-menu p-0"
            style={{
              maxHeight: "400px",
              overflowX: "hidden",
            }}
            right
          >
            <div className="dropdown-header d-flex align-items-center justify-content-between bg-pink">
              <h4 className="text-white d-flex align-items-center mt-2 text-align--center">
                All Notifications
              </h4>
              {editAccess && (
                <>
                  <button
                    className="btn btn-sm mt-2 text-danger bg-white ml-1"
                    type="button"
                    onClick={handleClearAll}
                    disabled={
                      clearAllLoader ||
                      unreadLoader ||
                      unreadNotifications?.length === 0
                    }
                  >
                    Clear All
                  </button>
                </>
              )}
            </div>
            {getAccess ? (
              <>
                {unreadLoader ? (
                  <div className="d-flex align-items-center justify-content-center py-5">
                    <Spinner size="md" color="primary" />
                  </div>
                ) : (
                  <>
                    {unreadNotifications.length > 0 ? (
                      <div
                        className="notification-scroll-area"
                        style={{
                          maxHeight: "250px",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        {unreadNotifications
                          ?.slice(0, 5)
                          ?.map((notif, index) => {
                            const timestamp = notif?.createdAt;
                            const unixTimestamp =
                              timestamp.seconds * 1000 +
                              timestamp.nanoseconds / 1000000;
                            const date = moment.unix(unixTimestamp / 1000);
                            const formattedDateTime =
                              date.format("MMM DD HH:mma");

                            return (
                              <React.Fragment key={index}>
                                <Row className="mt-2 ml-2 d-flex align-items-center cursor-pointer">
                                  <Col
                                    md={2}
                                    className="d-flex align-items-center justify-content-center p-0"
                                    style={{ width: "60px" }}
                                  >
                                    <img
                                      src={notif?.imageUrl || userAvatar}
                                      alt="User Profile"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "60px",
                                      }}
                                    />
                                  </Col>
                                  <Col
                                    md={10}
                                    className="d-flex flex-column pl-2"
                                  >
                                    <span className="text-wrap mb-1 fs-14">
                                      <b>{notif?.name}</b> {notif?.message}
                                    </span>
                                    <div className="d-flex justify-content-between fs-12">
                                      <small>{formattedDateTime}</small>
                                      {(editAccess ||
                                        user?.type === "restaurant") &&
                                        notif?.markAsRead !== true && (
                                          <small
                                            className="text-primary mr-2"
                                            onClick={() =>
                                              dispatch(
                                                updateNotification(
                                                  user?.restaurantID,
                                                  notif.id
                                                )
                                              )
                                            }
                                          >
                                            Mark as Read
                                          </small>
                                        )}
                                    </div>
                                  </Col>
                                </Row>
                              </React.Fragment>
                            );
                          })}
                      </div>
                    ) : (
                      <Row className="justify-content-center py-4 mx-0">
                        No Notifications
                      </Row>
                    )}
                    <hr className="my-2" />
                    <div
                      className="dropdown-footer mb-2 d-flex align-items-center justify-content-center"
                      style={{ cursor: "pointer" }}
                    >
                      <button
                        className="btn"
                        type="button"
                        onClick={() => {
                          toggleDropdown();
                          history.push("/admin/notifications");
                        }}
                      >
                        {getAccess && (
                          <>
                            {getNotificationsLoader ? (
                              <Spinner size="sm" color="primary" />
                            ) : (
                              "View All"
                            )}
                          </>
                        )}
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <Card className="shadow py-5 justify-content-center align-items-center">
                You don't have the permission to access the page
              </Card>
            )}
          </DropdownMenu>
        )}
      </UncontrolledDropdown>
    </>
  );
};

export default Notifications;
